const getWebsiteInfo = state => {
    return state.websiteInfo[0];
};

export default {
    getWebsiteInfo,
};
